export enum TableStatusType {
    Ordered,
    Recived,
    Served,
    Paid,
    Free,
    Bill
}

export function tableStatusTypeToString(status: TableStatusType): string {
    switch (status) {
        case TableStatusType.Ordered:
            return "Poručeno";
        case TableStatusType.Recived:
            return "Primljeno";
        case TableStatusType.Served:
            return "Usluženo";
        case TableStatusType.Paid:
            return "Plaćeno";
        case TableStatusType.Free:
            return "Slobodno";
        case TableStatusType.Bill:
            return "Račun";
        default:
            return "Nepoznat status";
    }
}

export function tableStatusTypeToColor(status: TableStatusType): string {
    switch (status) {
        case TableStatusType.Ordered:
            return "ordered";
        case TableStatusType.Recived:
            return "recived";
        case TableStatusType.Served:    
            return "served";
        case TableStatusType.Paid:
            return "paid";
        case TableStatusType.Free:
            return "";
        case TableStatusType.Bill:
            return "bill";
        default:
            return "";
    }
}